import { schema } from 'normalizr';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import accountSchema from './accountSchema';

const physicalAddressSchema = new schema.Entity(
  'physicalAddresses',
  {
    account: accountSchema,
  },
  {
    processStrategy: (entity) => mapKeysToCamelCase(entity, true),
  }
);

export default physicalAddressSchema;
